!function($) {
	$.scrolltotop = function(options) {
		var settings = jQuery.extend({
			backToTop: "#js-backtotop",
			winHeight: 1.5 * $(window).innerHeight()
		},
		options),
		$backToTop = $(settings.backToTop);
		$(window).on("scroll",
		function() {
			$(window).scrollTop() > settings.winHeight ? $backToTop.fadeIn(200) : $backToTop.fadeOut(200)
		}),
		$backToTop.on("click",
		function() {
			$("html,body").animate({
				scrollTop: 0
			},
			500)
		})
	}
} (jQuery),
$(document).ready(function() {
	$.scrolltotop({
		backToTop: "#js-backtotop"
	})
}),
$.preHash = !1,
function() {
	var currentHash = $.hash.get();
	$.preHash !== currentHash && currentHash && ($.preHash = currentHash, $.execute($.hash.parse("/", currentHash))),
	setTimeout(arguments.callee, 50)
} ();
//# sourceMappingURL=../maps/js/eyeglasses.js.map
